import { MembershipBucket } from './SubscriptionsModels';
import { UserModel } from './User';

export enum MaxDepartureAirportCount {
    MAX_PREMIUM_DEPARTURE = 4,
    MAX_FREE_DEPARTURE = 1
}

export enum MaxDestinationCount {
    MAX_PREMIUM_DESTINATION = 10,
    MAX_FREE_DESTINATION = 3
}

export const departureLimitByBucket: Record<MembershipBucket, number> = {
    [MembershipBucket.Free]:        MaxDepartureAirportCount.MAX_FREE_DEPARTURE,
    [MembershipBucket.Premium]:     MaxDepartureAirportCount.MAX_PREMIUM_DEPARTURE,
    [MembershipBucket.PremiumPlus]: MaxDepartureAirportCount.MAX_PREMIUM_DEPARTURE,
};

export const destinationLimitByBucket: Record<MembershipBucket, number> = {
    [MembershipBucket.Free]:        MaxDestinationCount.MAX_FREE_DESTINATION,
    [MembershipBucket.Premium]:     MaxDestinationCount.MAX_PREMIUM_DESTINATION,
    [MembershipBucket.PremiumPlus]: MaxDestinationCount.MAX_PREMIUM_DESTINATION,
};


